<template>
    <div class="glide">
        <div data-glide-el="track" class="glide__track">
            <ul class="glide__slides">
                <slot></slot>
            </ul>
            <slot name="voteButton"></slot>
        </div>
        <div class="controls" data-glide-el="controls">
            <button class="controls__prev" data-glide-dir="<"></button>
            <button class="controls__next" data-glide-dir=">"></button>
        </div>
        <slot name="bullets"></slot>
    </div>
</template>

<script>
import Glide from '@glidejs/glide';

export default {
  data() {
    return {
      currentSerie: 0,
    };
  },
  mounted() {
    const glide = new Glide('.glide', {
      type: 'carousel',
      startAt: Math.random() * 10,
      gap: 20,
      perView: 4,
      focusAt: 'center',
      breakpoints: {
        700: {
          gap: 17,
          perView: 1.5,
        },
      },
    });
    glide.on('run', () => {
      this.currentSerie = glide.index;
      this.$emit('slide', this.currentSerie);
    });

    glide.mount();
  },
};
</script>

<style lang="scss">
.glide {
    position:relative;
    &__slides {
        overflow: visible;
    }

    &__track {
        margin-bottom: var(--spacing-l);
        position: relative;
    }

    .controls {
        width: 100%;
        display: flex;
        justify-content: space-between;
        top: 50%;
        position: absolute;
        padding: 0 5%;
        transform: translateY(-50%);

        @include media('>m') {
          display: none;
        }

        &__prev, &__next {
            border: 0px;
            height: 20px;
            width: 20px;
            transform: rotate(45deg);
            border-color: var(--color-white);
            border-style: solid;
            background: transparent;
            padding: 0;
            margin: 0;
        }

        &__prev {
            border-left: 2px solid var(--color-white);
            border-bottom: 2px solid var(--color-white);
        }

        &__next {
            border-top: 2px solid var(--color-white);
            border-right: 2px solid var(--color-white);
        }
    }

}
</style>
